<mobi-content-section
  [id]="paragraph().anchorLinkUrl ? paragraph().anchorLinkUrl : paragraph().id"
  [content]="content"
  width="full"
  [mobiTracking]="paragraph()"
>
  <ng-template #content>
    <div class="mobi-ui-grid mobi-ui-ink-default" [class]="{ twocol: paragraph().image }">
      @if (paragraph().image) {
        <div class="mobi-ui-col-1/1 md:mobi-ui-col-1/2">
          <mobi-media
            class="block"
            [entity]="paragraph().image"
            responsiveStyle="portrait_half"
          />
        </div>
      }
      <div
        class="self-stretch mobi-ui-col-1/1"
        [class]="{
          'md:mobi-ui-col-1/2': paragraph().image,
          'lg:pr-[60px]': paragraph().image,
        }"
      >
        @if (paragraph().image) {
          <ng-container [ngTemplateOutlet]="intro" />
        } @else if (paragraph().title || paragraph().text) {
          <!-- same width as pg_txt -->
          <div class="mobi-ui-grid is-centered">
            <div class="mobi-ui-col-1/1 md:mobi-ui-col-2/3 xl:mobi-ui-col-1/2">
              <ng-container [ngTemplateOutlet]="intro" />
            </div>
          </div>
        }
        <mobi-webform [webformId]="paragraph().form.id" [isParagraph]="true" />
      </div>
    </div>
  </ng-template>

  <ng-template #intro>
    @if (paragraph().title) {
      <mobi-heading-select
        class="block"
        [class]="{ 'text-center': !paragraph().image }"
        [title]="paragraph().title"
        [headingType]="paragraph().titleSize"
        [headingStyle]="paragraph().titleSize"
      />
    }
    @if (paragraph().text) {
      <mobi-text
        class="text-read block"
        [class]="{ 'text-center': !paragraph().image }"
        [data]="paragraph().text"
      />
    }
  </ng-template>
</mobi-content-section>
